export function ImgCost({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.75-13.75H15a1,1,0,0,0,0-2H13.25A2.75,2.75,0,0,0,10.5,7H10a1,1,0,0,0,0,2h.5V15H10a1,1,0,0,0,0,2h.5a2.75,2.75,0,0,0,2.75-2.75H15a1,1,0,0,0,0-2h-1.75ZM11.75,10H13.25a.75.75,0,0,1,0,1.5H11.75Zm0-3H13.25a.75.75,0,0,1,0,1.5H11.75Z" />
    </svg>
  );
}
